/**
 * Pendant zu `<div class="@GetRowColorCssClass(Model)"></div>`. Das Element wird auch bei
 * leerer Klasse ausgegeben, damit das DOM dem Altclient entspricht; das Grid färbt die
 * Zeile über `tr:has(td .row-…)` (REQ-05 §3).
 */

export interface RowColorMarkerProps {
  className: string;
}

export function RowColorMarker(props: RowColorMarkerProps) {
  return <div className={props.className} />;
}

export default RowColorMarker;
